const aiCollege = [
    {
      title: '電控與工業通訊聯網暨大數據AI應用單元系列',
      date: '2022/09/28',
      url: 'https://college.itri.org.tw/Lesson/LessonData/31CFBDA8-6825-41D8-849F-70F4F4B0E522'
    },
    {
      title: '網絡安全人工智慧實作',
      date: '2022/09/21',
      url: 'https://college.itri.org.tw/Lesson/LessonData/69356C1D-1481-41C8-8F91-4BC2BD3D8C5E'
    },
    {
      title: 'ChatGPT+Excel動態數據基礎管理實務',
      date: '2022/09/19',
      url: 'https://college.itri.org.tw/Lesson/LessonData/C2DFD70A-5317-4F2A-8D15-4D7C3E4A7B46'
    },
    {
      title: '【政府補助】Python AI人工智慧資料分析師',
      date: '2022/09/19',
      url: 'https://college.itri.org.tw/Lesson/LessonData/360C6073-469C-4906-A3B7-6A97D82E1386'
    },
    {
      title: '【線上自學】量子電路設計與應用',
      date: '2022/09/19',
      url: 'https://college.itri.org.tw/Lesson/LessonData/80D6F25E-D8A1-4DC7-BD2A-4DE4D1A413D4'
    },
    {
      title: '【線上自學】企業資安管理與應用系列課程',
      date: '2022/09/19',
      url: 'https://college.itri.org.tw/Lesson/LessonData/0023200A-5524-4969-855F-1B86C63D193E'
    },
  ]
  
  export default aiCollege;